import React from 'react';
import { UIHeading4, IconFunctionalInformationCircle16 } from '@cian/ui-kit';

// import { useAppDispatch } from 'shared/utils/hooks';
// import { openPopup } from 'shared/features/popups';
// import { PopupType } from 'shared/types/popups';

import styles from './styles.css';
import { IStaticElement } from '../../../types/calculator';

export const ProgramFeaturesButton: React.FC<IStaticElement> = props => {
  const { label: text } = props;

  // const dispatch = useAppDispatch();

  const handleClick = () => {
    // TODO: перенести логику попапа
    // dispatch(
    //   openPopup({
    //     type: PopupType.Programs,
    //     data: null,
    //   }),
    // );
  };

  return (
    <button className={styles.root} type="button" onClick={handleClick} data-testid="form-feature-button">
      <UIHeading4 color="primary_100">{text}</UIHeading4>
      <IconFunctionalInformationCircle16 color="primary_100" />
    </button>
  );
};

ProgramFeaturesButton.displayName = 'ProgramFeaturesButton';
